import { cn } from "@/lib/utils";

export default function LinkIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("size-4 text-white", className)}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.8887 2.1041C12.5874 0.802802 10.4776 0.802807 9.17633 2.1041L6.63025 4.65018C7.47047 4.45785 8.36945 4.55634 9.16998 4.93887L10.5905 3.51831C11.1108 2.99807 11.9543 2.99807 12.4745 3.51831C12.9948 4.03856 12.9948 4.88204 12.4745 5.40229L9.39041 8.4864C8.87016 9.00665 8.02667 9.00664 7.50643 8.4864C7.30752 8.2875 7.18467 8.04134 7.13786 7.78407C7.10864 7.80523 7.08089 7.82882 7.05488 7.85483L5.61319 9.29652C5.74618 9.5113 5.90585 9.71425 6.09222 9.90061C7.39351 11.2019 9.50333 11.2019 10.8046 9.90061L13.8887 6.8165C15.19 5.51521 15.19 3.40539 13.8887 2.1041Z"
        fill="currentColor"
      />
      <path
        d="M6.8218 11.0558L5.40215 12.4754C4.88191 12.9956 4.03842 12.9956 3.51817 12.4754C2.99793 11.9552 2.99793 11.1117 3.51817 10.5914L6.60229 7.50732C7.12253 6.98707 7.96602 6.98707 8.48626 7.50731C8.6855 7.70655 8.80843 7.95319 8.85507 8.21093C8.88423 8.1898 8.91194 8.16623 8.9379 8.14027L10.3801 6.6981C10.247 6.48299 10.0871 6.27973 9.90048 6.0931C8.59918 4.79181 6.48937 4.79181 5.18807 6.0931L2.10396 9.17721C0.802667 10.4785 0.802667 12.5883 2.10396 13.8896C3.40526 15.1909 5.51507 15.1909 6.81637 13.8896L9.36063 11.3454C8.5206 11.5372 7.62198 11.4384 6.8218 11.0558Z"
        fill="currentColor"
      />
    </svg>
  );
}
